export enum TwikeyState {
    Paid = "paid",
    Declined = "declined",
    Expired = "expired",
    Pending = "pending",
    Created = "created",
    Started = "started"
}